<template>
    <div class="filterbar-challenge-list">
        <button
            v-for="filtertag in this.$store.state.filtertagsChallengeList"
            :key="filtertag.id"
            class="btn-filterbar-challenge-list"
            :class="filtertag.type === this.$store.state.selectedFiltertagChallengeList.type ? 'btn-filterbar-challenge-list--selected' : ''"
            @click="selectFiltertag(filtertag)">
            <span class="btn-filterbar-challenge-list__text">{{ filtertag.label }}</span>
        </button>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        methods: {
            selectFiltertag(filtertag){
                this.$store.commit('setSelectedFiltertagChallengeList', filtertag);
            }
        }
    };
</script>

<style scoped src="@/css/components/filterbar-challenge-list.css"></style>